import * as React from 'react'
import { H1, Spacer, IntroText } from '../../../../common/src/components/core'

export default function OtherUsersDetail() {
  return (
    <div>
      <H1>Other Users</H1>
      <Spacer height={32} />
      <IntroText>
        SALES users can view CC, but can't change anything or send messages. This is useful for salespeople, etc.
      </IntroText>
      <Spacer height={16} />
      <IntroText>DISABLED users are former users that no longer have access to CC.</IntroText>
      <Spacer height={32} />
    </div>
  )
}
